import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'suvo-bi-organisation-invites-view',
  templateUrl: './organisation-invites-view.component.html',
  styleUrls: ['./organisation-invites-view.component.scss'],
})
export class OrganisationInvitesViewComponent {}
